export default __webpack_public_path__ + "static/media/background-main.6ffad1f9.jpg";